<template>
  <div class="bcb">
    <template v-for="(item, i) in items">
      <section :key="`Breadcrumbs-${item.title}`" class="bcb__item">
        <div v-if="i > 0" class="bcb__sp">{{ separator(i) }}</div>
        <breadcrumb-item :value="item.title" :path="item.path" :new-tab="item.newTab" :query="item.query" />
      </section>
    </template>
  </div>
</template>

<script>
import BreadcrumbItem from './breadcrumbItem'

const home = 'general.home'

export default {
  components: {
    'breadcrumb-item': BreadcrumbItem,
  },
  computed: {
    items() {
      let arr = [
        {
          path: '/',
          title: this.$t(home),
        },
      ]
      if (this.value) {
        arr = arr.concat(this.value)
      }
      return arr
    },
  },
  methods: {
    separator(index) {
      return index === 1 ? '>' : '/'
    },
  },
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
}
</script>

<style lang="postcss" scoped>
.bcb {
  @apply flex flex-row my-3 truncate mr-4 flex-wrap;
}
.bcb__item {
  @apply flex flex-row text-grey-medium items-center;
}
.bcb__sp {
  @apply mx-1;
}

@screen mobile {
  .bcb {
    @apply px-3;
  }
}

@screen desktop {
  .bcb {
    @apply px-4;
  }
}
</style>
